import { LinkButton as AranduLinkButton, LinkButtonProps as AranduLinkButtonProps } from '@ads/components-react';
import { useNavigate } from 'react-router';

interface LinkButtonProps extends AranduLinkButtonProps {
  href?: string;
  replace?: boolean;
}

const LinkButton = ({ href, children, replace, onClick, ...props }: LinkButtonProps) => {
  const nav = useNavigate();

  return (
    /* FIXME:
     * Como não é possível renderizar um Link (<a></a>) com os estilos do LinkButton
     * eu fiz essa condicional pra ele se comportar parecido com um link
     * mas no html ainda vai renderizar um <button> ao invés de um <a>
     * o ideal é o LinkButton ter uma propriedade asChild pra renderizar o children mas passando as props de LinkButton pra esse children
     */
    <AranduLinkButton
      onClick={(e) => {
        if (href) {
          nav(href, { replace });
          return;
        }

        if (onClick) {
          onClick(e);
        }
      }}
      {...props}
    >
      {children}
    </AranduLinkButton>
  );
};

export { LinkButton };
